import { prop } from "ramda";
import { createSelector } from "reselect";

import { STATE_IDENTIFIER } from "./constants";

const {
  REPORTS,
  REPORTS_LOADER,
  SELECTED_REPORT,
  REPORT_PARAMETERS,
  VALUE,
  CAMPAIGN_NAMES,
  RESPONSE_STATE,
} = STATE_IDENTIFIER;

const reportReferenceSelector = (state: any) => state.report;

export const selectReports: any = createSelector(
  reportReferenceSelector,
  prop(REPORTS)
);

export const selectReportsLoader: any = createSelector(
  reportReferenceSelector,
  prop(REPORTS_LOADER)
);

export const selectSelectedReport: any = createSelector(
  reportReferenceSelector,
  prop(SELECTED_REPORT)
);

export const selectReportParameters: any = createSelector(
  reportReferenceSelector,
  prop(REPORT_PARAMETERS)
);

export const selectReportValue: any = createSelector(
  reportReferenceSelector,
  prop(VALUE)
);

export const selectResponseState: any = createSelector(
  reportReferenceSelector,
  prop(RESPONSE_STATE)
);

export const selectCampaignNames: any = createSelector(
  reportReferenceSelector,
  prop(CAMPAIGN_NAMES)
);
